import { render, staticRenderFns } from "./SetupDetails.vue?vue&type=template&id=92118d1a&scoped=true&"
import script from "./SetupDetails.vue?vue&type=script&lang=js&"
export * from "./SetupDetails.vue?vue&type=script&lang=js&"
import style0 from "./SetupDetails.vue?vue&type=style&index=0&id=92118d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92118d1a",
  null
  
)

/* custom blocks */
import block0 from "./SetupDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports